import { QuestionError } from '@sm/question-definitions';
import { SurveyError } from './types';
import { ErrorType } from './constants';

export const transformToSurveyErrors = <F extends QuestionError>(errors: F[]): SurveyError[] => {
  return errors.map(({ detail, questionId, type }: F) => ({
    questionId,
    detail,
    code: type?.includes('REQUIRED') ? ErrorType.MISSING_REQUIRED_FIELD : ErrorType.FAILED_VALIDATION,
  })) as SurveyError[];
};

export default transformToSurveyErrors;
